// create_contest_general
export const CREATE_CONTEST_GENERAL = 'create_contest_general';
export const CREATE_CONTEST_GENERAL_SUCCESSFUL =
  'create_contest_general_successfull';
export const CREATE_CONTEST_GENERAL_FAILED = 'create_contest_general_failed';
// get_contest_general
export const GET_CONTEST_GENERAL = 'get_contest_general';
export const GET_CONTEST_GENERAL_SUCCESSFUL = 'get_contest_general_successfull';
export const GET_CONTEST_GENERAL_FAILED = 'get_contest_general_failed';
// update_contest_general
export const UPDATE_CONTEST_GENERAL = 'update_contest_general';
export const UPDATE_CONTEST_GENERAL_SUCCESSFUL =
  'update_contest_general_successfull';
export const UPDATE_CONTEST_GENERAL_FAILED = 'update_contest_general_failed';

// create_contest_identity
export const CREATE_CONTEST_IDENTITY = 'create_contest_identity';
export const CREATE_CONTEST_IDENTITY_SUCCESSFUL =
  'create_contest_identity_successfull';
export const CREATE_CONTEST_IDENTITY_FAILED = 'create_contest_identity_failed';
// get_contest_identity
export const GET_CONTEST_IDENTITY = 'get_contest_identity';
export const GET_CONTEST_IDENTITY_SUCCESSFUL =
  'get_contest_identity_successfull';
export const GET_CONTEST_IDENTITY_FAILED = 'get_contest_identity_failed';
// update_contest_identity
export const UPDATE_CONTEST_IDENTITY = 'update_contest_identity';
export const UPDATE_CONTEST_IDENTITY_SUCCESSFUL =
  'update_contest_identity_successfull';
export const UPDATE_CONTEST_IDENTITY_FAILED = 'update_contest_identity_failed';

// create_contest_criteria
export const CREATE_CONTEST_CRITERIA = 'create_contest_criteria';
export const CREATE_CONTEST_CRITERIA_SUCCESSFUL =
  'create_contest_criteria_successfull';
export const CREATE_CONTEST_CRITERIA_FAILED = 'create_contest_criteria_failed';
// get_contest_criteria
export const GET_CONTEST_CRITERIA = 'get_contest_criteria';
export const GET_CONTEST_CRITERIA_SUCCESSFUL =
  'get_contest_criteria_successfull';
export const GET_CONTEST_CRITERIA_FAILED = 'get_contest_criteria_failed';
// update_contest_criteria
export const UPDATE_CONTEST_CRITERIA = 'update_contest_criteria';
export const UPDATE_CONTEST_CRITERIA_SUCCESSFUL =
  'update_contest_criteria_successfull';
export const UPDATE_CONTEST_CRITERIA_FAILED = 'update_contest_criteria_failed';

// create_contest_rules
export const CREATE_CONTEST_RULES = 'create_contest_rules';
export const CREATE_CONTEST_RULES_SUCCESSFUL =
  'create_contest_rules_successfull';
export const CREATE_CONTEST_RULES_FAILED = 'create_contest_rules_failed';
// get_contest_rules
export const GET_CONTEST_RULES = 'get_contest_rules';
export const GET_CONTEST_RULES_SUCCESSFUL = 'get_contest_rules_successfull';
export const GET_CONTEST_RULES_FAILED = 'get_contest_rules_failed';
// update_contest_rules
export const UPDATE_CONTEST_RULES = 'update_contest_rules';
export const UPDATE_CONTEST_RULES_SUCCESSFUL =
  'update_contest_rules_successfull';
export const UPDATE_CONTEST_RULES_FAILED = 'update_contest_rules_failed';

// get_contest
export const GET_CONTEST = 'get_contest';
export const GET_CONTEST_SUCCESSFUL = 'get_contest_successfull';
export const GET_CONTEST_FAILED = 'get_contest_failed';

export const RESET_CONTEST_CREATE = 'reset_contest_create';

// get_contest_categories
export const GET_CONTEST_CATEGORIES = 'get_contest_categories';
export const GET_CONTEST_CATEGORIES_SUCCESSFUL =
  'get_contest_categories_successfull';
export const GET_CONTEST_CATEGORIES_FAILED = 'get_contest_categories_failed';

// get_active_contesests
export const GET_ACTIVE_CONTESESTS = 'get_active_contesests';
export const GET_ACTIVE_CONTESESTS_SUCCESSFUL =
  'get_active_contesests_successfull';
export const GET_ACTIVE_CONTESESTS_FAILED = 'get_active_contesests_failed';
// get_pending_contesests
export const GET_PENDING_CONTESESTS = 'get_pending_contesests';
export const GET_PENDING_CONTESESTS_SUCCESSFUL =
  'get_pending_contesests_successfull';
export const GET_PENDING_CONTESESTS_FAILED = 'get_pending_contesests_failed';
// get_completed_contests
export const GET_COMPLETED_CONTESTS = 'get_completed_contests';
export const GET_COMPLETED_CONTESTS_SUCCESSFUL =
  'get_completed_contests_successfull';
export const GET_COMPLETED_CONTESTS_FAILED = 'get_completed_contests_failed';
// get_ongoing_contests
export const GET_ONGOING_CONTESTS = 'get_ongoing_contests';
export const GET_ONGOING_CONTESTS_SUCCESSFUL =
  'get_ongoing_contests_successfull';
export const GET_ONGOING_CONTESTS_FAILED = 'get_ongoing_contests_failed';
// get_drafted_contests
export const GET_DRAFTED_CONTESTS = 'get_drafted_contests';
export const GET_DRAFTED_CONTESTS_SUCCESSFUL =
  'get_drafted_contests_successfull';
export const GET_DRAFTED_CONTESTS_FAILED = 'get_drafted_contests_failed';
// get_all_contests
export const GET_ALL_CONTESTS = 'get_all_contests';
export const GET_ALL_CONTESTS_SUCCESSFUL = 'get_all_contests_successfull';
export const GET_ALL_CONTESTS_FAILED = 'get_all_contests_failed';

// delete_contest
export const DELETE_CONTEST = 'delete_contest';
export const DELETE_CONTEST_SUCCESSFUL = 'delete_contest_successfull';
export const DELETE_CONTEST_FAILED = 'delete_contest_failed';

// ---- entry ---- //
// get_contest_entries
export const GET_CONTEST_ENTRIES = 'get_contest_entries';
export const GET_CONTEST_ENTRIES_SUCCESSFUL = 'get_contest_entries_successfull';
export const GET_CONTEST_ENTRIES_FAILED = 'get_contest_entries_failed';

// delete_contest_entry
export const DELETE_CONTEST_ENTRY = 'delete_contest_entry';
export const DELETE_CONTEST_ENTRY_SUCCESSFUL =
  'delete_contest_entry_successfull';
export const DELETE_CONTEST_ENTRY_FAILED = 'delete_contest_entry_failed';

// ---- contest member-----//
// get_contest_pending_contestants
export const GET_CONTEST_PENDING_CONTESTANTS =
  'get_contest_pending_contestants';
export const GET_CONTEST_PENDING_CONTESTANTS_SUCCESSFUL =
  'get_contest_pending_contestants_successfull';
export const GET_CONTEST_PENDING_CONTESTANTS_FAILED =
  'get_contest_pending_contestants_failed';
// get_contest_accepted_contestants
export const GET_CONTEST_ACCEPTED_CONTESTANTS =
  'get_contest_accepted_contestants';
export const GET_CONTEST_ACCEPTED_CONTESTANTS_SUCCESSFUL =
  'get_contest_accepted_contestants_successfull';
export const GET_CONTEST_ACCEPTED_CONTESTANTS_FAILED =
  'get_contest_accepted_contestants_failed';
// get_contest_pending_judges
export const GET_CONTEST_PENDING_JUDGES = 'get_contest_pending_judges';
export const GET_CONTEST_PENDING_JUDGES_SUCCESSFUL =
  'get_contest_pending_judges_successfull';
export const GET_CONTEST_PENDING_JUDGES_FAILED =
  'get_contest_pending_judges_failed';
// get_contest_accepted_judges
export const GET_CONTEST_ACCEPTED_JUDGES = 'get_contest_accepted_judges';
export const GET_CONTEST_ACCEPTED_JUDGES_SUCCESSFUL =
  'get_contest_accepted_judges_successfull';
export const GET_CONTEST_ACCEPTED_JUDGES_FAILED =
  'get_contest_accepted_judges_failed';

// add_contest_member
export const ADD_CONTEST_MEMBER = 'add_contest_member';
export const ADD_CONTEST_MEMBER_SUCCESSFUL = 'add_contest_member_successfull';
export const ADD_CONTEST_MEMBER_FAILED = 'add_contest_member_failed';
// add_contest_member_reset
export const ADD_CONTEST_MEMBER_RESET = 'add_contest_member_reset';

// contest_contestant_permission
export const CONTEST_CONTESTANT_PERMISSION = 'contest_contestant_permission';
export const CONTEST_CONTESTANT_PERMISSION_SUCCESSFUL =
  'contest_contestant_permission_successfull';
export const CONTEST_CONTESTANT_PERMISSION_FAILED =
  'contest_contestant_permission_failed';

// remove_cotestant_or_judge
export const REMOVE_COTESTANT_OR_JUDGE = "remove_cotestant_or_judge";
export const REMOVE_COTESTANT_OR_JUDGE_SUCCESSFUL = "remove_cotestant_or_judge_successfull";
export const REMOVE_COTESTANT_OR_JUDGE_FAILED = "remove_cotestant_or_judge_failed";

//  ---- contest template ---- //
// get_contest_templates
export const GET_CONTEST_TEMPLATES = 'get_contest_templates';
export const GET_CONTEST_TEMPLATES_SUCCESSFUL =
  'get_contest_templates_successfull';
export const GET_CONTEST_TEMPLATES_FAILED = 'get_contest_templates_failed';

// create_contest_template
export const CREATE_CONTEST_TEMPLATE = 'create_contest_template';
export const CREATE_CONTEST_TEMPLATE_SUCCESSFUL =
  'create_contest_template_successfull';
export const CREATE_CONTEST_TEMPLATE_FAILED = 'create_contest_template_failed';
// reset_contest_template
export const RESET_CONTEST_TEMPLATE = 'reset_contest_template';

// delete_template
export const DELETE_TEMPLATE = 'delete_template';
export const DELETE_TEMPLATE_SUCCESSFUL = 'delete_template_successfull';
export const DELETE_TEMPLATE_FAILED = 'delete_template_failed';

// update_contest_template
export const UPDATE_CONTEST_TEMPLATE = 'update_contest_template';
export const UPDATE_CONTEST_TEMPLATE_SUCCESSFUL =
  'update_contest_template_successfull';
export const UPDATE_CONTEST_TEMPLATE_FAILED = 'update_contest_template_failed';
